import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createBlock(_component_q_icon, _mergeProps({
    name: "fa fa-star",
    color: _ctx.color,
    title: _ctx.title,
    class: {'fa-spin': _ctx.isLoading}
  }, _ctx.$attrs, {
    onClick: _withModifiers(_ctx.toggle, ["stop","prevent"])
  }), null, 16, ["color", "title", "class", "onClick"]))
}